import Card from '../../../../shared/types/props/card';
import HorizontalCard from './horizontalCard';

function CleanHorizontalCard({ item, index, onClick, releaseAction }: Card) {
  return (
    <HorizontalCard
      key={index}
      item={item}
      index={index}
      onClick={onClick}
      releaseAction={releaseAction}
      showInfo={false}
      showMask={false}
    />
  );
}

export default CleanHorizontalCard;
